import React from 'react';
import { AlertTriangle, Info } from 'lucide-react';
import { Card } from '../components/Card';
import { WarningBanner } from '../components/WarningBanner';
import { SEO } from '../components/SEO';
import { useLanguage } from '../hooks/useLanguage';
export function DisclaimerPage() {
  const {
    t
  } = useLanguage();
  return <div className="container mx-auto px-4 pt-24 pb-12 sm:pb-16 max-w-4xl" data-id="element-596">
      <SEO title={t('seo.disclaimer.title')} description={t('seo.disclaimer.desc')} data-id="element-597" />
      <div className="text-center mb-12 animate-fade-in" data-id="element-598">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-warning/10 rounded-2xl mb-6" data-id="element-599">
          <AlertTriangle className="h-8 w-8 text-warning" data-id="element-600" />
        </div>
        <h1 className="text-4xl font-bold mb-4" data-id="element-601">{t('disclaimer.title')}</h1>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto" data-id="element-602">
          {t('disclaimer.subtitle')}
        </p>
      </div>

      <WarningBanner message={t('disclaimer.banner')} variant="warning" dismissible={false} data-id="element-603" />

      <div className="mt-8 space-y-6" data-id="element-604">
        <Card className="animate-slide-up" data-id="element-605">
          <h2 className="text-2xl font-bold mb-4" data-id="element-606">
            {t('disclaimer.nature.title')}
          </h2>
          <div className="space-y-3 text-gray-700 leading-relaxed" data-id="element-607">
            <p data-id="element-608">{t('disclaimer.nature.desc')}</p>
          </div>
        </Card>

        <Card className="animate-slide-up" style={{
        animationDelay: '100ms'
      }} data-id="element-609">
          <h2 className="text-2xl font-bold mb-4" data-id="element-610">
            {t('disclaimer.data.title')}
          </h2>
          <div className="space-y-3 text-gray-700 leading-relaxed" data-id="element-611">
            <p data-id="element-612">{t('disclaimer.data.desc')}</p>
            <p data-id="element-613">{t('disclaimer.data.localStorage')}</p>
          </div>
        </Card>

        <Card className="animate-slide-up" style={{
        animationDelay: '200ms'
      }} data-id="element-614">
          <h2 className="text-2xl font-bold mb-4" data-id="element-615">
            {t('disclaimer.reporting.title')}
          </h2>
          <div className="space-y-3 text-gray-700 leading-relaxed" data-id="element-616">
            <p data-id="element-617">{t('disclaimer.reporting.desc')}</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-618">
              <li data-id="element-619">{t('disclaimer.reporting.police')}</li>
              <li data-id="element-620">{t('disclaimer.reporting.bank')}</li>
              <li data-id="element-621">{t('disclaimer.reporting.platform')}</li>
              <li data-id="element-622">{t('disclaimer.reporting.consumer')}</li>
            </ul>
            <p data-id="element-623">{t('disclaimer.reporting.note')}</p>
          </div>
        </Card>

        <Card className="animate-slide-up" style={{
        animationDelay: '300ms'
      }} data-id="element-624">
          <h2 className="text-2xl font-bold mb-4" data-id="element-625">
            {t('disclaimer.accuracy.title')}
          </h2>
          <div className="space-y-3 text-gray-700 leading-relaxed" data-id="element-626">
            <p data-id="element-627">{t('disclaimer.accuracy.desc')}</p>
            <p data-id="element-628">{t('disclaimer.accuracy.verify')}</p>
          </div>
        </Card>

        <Card className="animate-slide-up" style={{
        animationDelay: '400ms'
      }} data-id="element-629">
          <h2 className="text-2xl font-bold mb-4" data-id="element-630">
            {t('disclaimer.liability.title')}
          </h2>
          <div className="space-y-3 text-gray-700 leading-relaxed" data-id="element-631">
            <p data-id="element-632">{t('disclaimer.liability.desc')}</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-633">
              <li data-id="element-634">{t('disclaimer.liability.use')}</li>
              <li data-id="element-635">{t('disclaimer.liability.delays')}</li>
              <li data-id="element-636">{t('disclaimer.liability.actions')}</li>
              <li data-id="element-637">{t('disclaimer.liability.inaccuracies')}</li>
              <li data-id="element-638">{t('disclaimer.liability.thirdParty')}</li>
            </ul>
          </div>
        </Card>

        <Card className="bg-blue-50 border-blue-100 animate-slide-up" style={{
        animationDelay: '500ms'
      }} data-id="element-639">
          <div className="flex items-start space-x-4" data-id="element-640">
            <Info className="h-6 w-6 text-info flex-shrink-0 mt-1" data-id="element-641" />
            <div data-id="element-642">
              <h3 className="text-xl font-bold mb-2 text-blue-900" data-id="element-643">
                {t('disclaimer.questions.title')}
              </h3>
              <p className="text-blue-800 leading-relaxed" data-id="element-644">
                {t('disclaimer.questions.desc')}
              </p>
            </div>
          </div>
        </Card>
      </div>

      <div className="mt-12 text-center text-sm text-muted-foreground" data-id="element-645">
        {t('disclaimer.lastUpdated')}
      </div>
    </div>;
}